/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Rate range configurations are defined here
 * upper and lower limits, specified color codes for background color and text color in heat map are included
 * in a single configuration object
 */
const rateRange = [
  {
    lower: null,
    upper: 10,
    label: '10 >',
    backgroundColor: '#FFB0B2',
    textColor: '#000000',
  },
  {
    lower: 10,
    upper: 30,
    label: '10 - 30',
    backgroundColor: '#FFDFB2',
    textColor: '#000000',
  },
  {
    lower: 30,
    upper: 50,
    label: '30 - 50',
    backgroundColor: '#FFF9B4',
    textColor: '#000000',
  },
  {
    lower: 50,
    upper: 80,
    label: '50 - 80',
    backgroundColor: '#DBFFB9',
    textColor: '#000000',
  },
  {
    lower: 80,
    upper: 100,
    label: '80 - 100',
    backgroundColor: '#B6EEC0',
    textColor: '#000000',
  },
];
export default rateRange;
/**
 * Selected date color in rate calendar is defined here
 */
export const selectedDateColor = '#ebebeb';
/**
 * Heat map related color codes are defined here
 */
export const heatMapOffBackground = '#ffffff';
//
export const heatMapOnTextColor = '#000000';
